// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"_1La4CiAZZrMKXn5f2qslw-"};